<template>
  <div class="flex flex-col items-start">
    <InputLabel v-if="props.label" :optional="!props.required">
      {{ props.label }}
    </InputLabel>
    <ClientOnly>
      <VueSelect
        :id="id"
        class="select w-full"
        :clearable="false"
        :disabled="props.disabled"
        :model-value="selectedOption"
        :options="props.options"
        :placeholder="props.placeholder"
        :searchable="false"
        @update:model-value="onUpdate"
      >
        <template #open-indicator="{ attributes }">
          <div
            class="flex h-6 items-center justify-center border-l border-black/10 pl-3"
          >
            <svg
              class="fill-current"
              width="10"
              height="5"
              xmlns="http://www.w3.org/2000/svg"
              v-bind="attributes"
            >
              <path d="M10 0H0l5 5 5-5Z" />
            </svg>
          </div>
        </template>
      </VueSelect>
    </ClientOnly>
    <InputError :error="errorMessage" />
  </div>
</template>

<script setup lang="ts" generic="T extends number | string">
import type { BaseInputProps } from '@/components/base/input/types'
import type { InputProps } from './types'

interface Option {
  label: string
  value: T
}

interface InputSelectProps extends BaseInputProps, InputProps {
  options: Option[]
}

const props = defineProps<InputSelectProps>()
const { id, value, errorMessage } = useInput<T>(props.name)

const selectedOption = computed(() =>
  props.options.find((option) => option.value === value.value),
)

const onUpdate = (option: Option) => {
  value.value = option.value
}
</script>
